export default "__VITE_ASSET__DERE6xxy__"